import CancelOutlined from '@mui/icons-material/CancelOutlined'
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline'
import ExitToApp from '@mui/icons-material/ExitToApp'
import { useGetWorkflowStateEvents } from '@/service-library/hooks/workflow-state-events'
import { SUPER_USER_ONLY_COLOR } from '@/theme/usePixydocsTheme'
import {
  SYSTEM_EVENT_CODES_FILTER,
  sortSystemEvents,
} from '@/utils/workflow-state-events'

type UseSystemEventTriggersOptions = {
  workflowStateId?: string
  enabled?: boolean
}

/**
 * The system events a workflow state actually has, in the same order the
 * state's configuration page lists them. Menus offer a "run it now" item per
 * event, so a state without an On Exit event never offers to run one.
 */
export function useSystemEventTriggers({
  workflowStateId,
  enabled = true,
}: UseSystemEventTriggersOptions) {
  const { workflowStateEvents } = useGetWorkflowStateEvents({
    filters: {
      workflow_state_id: workflowStateId || '',
      code__in: SYSTEM_EVENT_CODES_FILTER,
    },
    enabled: enabled && !!workflowStateId,
  })

  return sortSystemEvents(workflowStateEvents)
}

type SystemEventIconProps = {
  code: string
}

export function SystemEventIcon({ code }: SystemEventIconProps) {
  const color = SUPER_USER_ONLY_COLOR

  if (code === 'on_exit')
    return <ExitToApp sx={{ color, transform: 'rotate(180deg)' }} />
  if (code === 'approvals_met') return <CheckCircleOutline sx={{ color }} />
  if (code === 'approvals_rejected') return <CancelOutlined sx={{ color }} />

  return <ExitToApp sx={{ color }} />
}
